module.exports = __webpack_public_path__ + "static/img/main_point_img05.d25bc6b9.svg";